import ProfStudyAids from './study-aids';

export default ProfStudyAids;